import { useState, useEffect } from "react";

import axios from "axios";

import classnames from "classnames";

import { ScrollMenu } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";

// import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import "react-horizontal-scrolling-menu/dist/styles.css";
import {
  FaChevronLeft,
  FaChevronRight,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { RxTriangleLeft } from "react-icons/rx";

import BarLoader from "react-spinners/BarLoader";
// import { Button } from 'reactstrap';

import { useTranslation } from "react-i18next";

function SportsPage() {
  const { t } = useTranslation("common");

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  // NEWS

  const [newsCategories, setNewsCategories] = useState();
  const fetchNewsCategories = async () => {
    const options = {
      method: "GET",
      url: "https://flashlive-sports.p.rapidapi.com/v1/news/categories",
      params: { locale: "en_INT" },
      headers: {
        "X-RapidAPI-Key": "3fefe14d2dmsh136127b00ab3064p19a2d2jsn1cb73ff98a5e",
        "X-RapidAPI-Host": "flashlive-sports.p.rapidapi.com",
      },
    };

    try {
      setIsLoading(true);

      await axios.request(options).then((res) => {
        let fetchedCategories = [];
        res.data.DATA.forEach((category) => {
          fetchedCategories.push(category);
        });
        // console.log(fetchedCategories);
        setNewsCategories(fetchedCategories);

        setIsLoading(false);
      });
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const [mostReadNews, setMostReadNews] = useState();
  const fetchMostReadNews = async () => {
    const options = {
      method: "GET",
      url: "https://flashlive-sports.p.rapidapi.com/v1/news/most-read",
      params: { locale: "en_INT" },
      headers: {
        "X-RapidAPI-Key": "3fefe14d2dmsh136127b00ab3064p19a2d2jsn1cb73ff98a5e",
        "X-RapidAPI-Host": "flashlive-sports.p.rapidapi.com",
      },
    };

    try {
      setIsLoading(true);

      await axios.request(options).then((res) => {
        let fetchedNews = [];
        res.data.DATA.forEach((newsArticle) => {
          fetchedNews.push(newsArticle);
        });
        // console.log(fetchedNews);
        setMostReadNews(fetchedNews);

        setIsLoading(false);
      });
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const [activeNewsCategoryNews, setActiveNewsCategoryNews] = useState();
  const fetchActiveNewsCategoryNews = async (tab) => {
    const options = {
      method: "GET",
      url: "https://flashlive-sports.p.rapidapi.com/v1/news/list",
      params: {
        entity_id: tab.ENTITY_ID,
        category_id: tab.CATEGORY_ID,
        locale: "en_INT",
        page: "0",
      },
      headers: {
        "X-RapidAPI-Key": "3fefe14d2dmsh136127b00ab3064p19a2d2jsn1cb73ff98a5e",
        "X-RapidAPI-Host": "flashlive-sports.p.rapidapi.com",
      },
    };

    try {
      setIsLoading(true);

      await axios.request(options).then(async (res) => {
        let fetchedActiveNewsCategoryNews = [];

        const options = {
          method: "GET",
          url: "https://flashlive-sports.p.rapidapi.com/v1/news/summary",
          params: {
            article_id: res.data.DATA.SECTIONS[0].ARTICLES[0].ID,
            locale: "en_INT",
          },
          headers: {
            "X-RapidAPI-Key":
              "3fefe14d2dmsh136127b00ab3064p19a2d2jsn1cb73ff98a5e",
            "X-RapidAPI-Host": "flashlive-sports.p.rapidapi.com",
          },
        };

        try {
          setIsLoading(true);

          await axios.request(options).then((res) => {
            setIsLoading(false);

            fetchedActiveNewsCategoryNews.push(res.data.DATA);
          });
        } catch (error) {
          console.error(error);
          setIsLoading(false);
        }

        console.log(fetchedActiveNewsCategoryNews);

        console.log(res.data.DATA.SECTIONS);

        for (let i = 0; i < 7; i++) {
          let options1 = {
            method: "GET",
            url: "https://flashlive-sports.p.rapidapi.com/v1/news/summary",
            params: {
              article_id:
                res.data.DATA.SECTIONS.length > 2
                  ? res.data.DATA.SECTIONS[2].ARTICLES[i]?.ID
                  : res.data.DATA.SECTIONS[1].ARTICLES[i]?.ID,
              locale: "en_INT",
            },
            headers: {
              "X-RapidAPI-Key":
                "3fefe14d2dmsh136127b00ab3064p19a2d2jsn1cb73ff98a5e",
              "X-RapidAPI-Host": "flashlive-sports.p.rapidapi.com",
            },
          };

          try {
            setIsLoading(true);

            await axios.request(options1).then((res) => {
              setIsLoading(false);

              fetchedActiveNewsCategoryNews.push(res.data.DATA);
            });
          } catch (error) {
            console.error(error);
            setIsLoading(false);
          }
        }

        setActiveNewsCategoryNews(fetchedActiveNewsCategoryNews);

        setIsLoading(false);
      });
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const [activeNewsTab, setActiveNewsTab] = useState("ALL");
  const toggleActiveNewsTab = (tab) => {
    setActiveNewsTab(tab);

    if (tab !== "ALL") {
      setActiveNewsTab(tab);
      fetchActiveNewsCategoryNews(tab);
    }
  };

  //

  const [activeMainTab, setActiveMainTab] = useState("SCORES");
  const toggleActiveMainTab = (tab) => {
    setActiveMainTab(tab);
    if (tab === "NEWS") {
      if (!(mostReadNews?.length > 0)) {
        fetchMostReadNews();
        fetchNewsCategories();
      }
    } else if (tab === "SCORES") {
      setActiveScoresTab("SOCCER");
    }
  };

  // const [selectedSport, setSelectedSport] = useState();
  // const selectSport = (sport) => {
  //   if (sport === selectedSport){
  //     setSelectedSport()
  //   } else {
  //     setSelectedSport(sport)
  //   }
  // }

  // const [selectedWhereFrom, setSelectedWhereFrom] = useState();
  // const selectWhereFrom = (whereFrom) => {
  //   if (whereFrom === selectedWhereFrom){
  //     setSelectedWhereFrom()
  //   } else {
  //     setSelectedWhereFrom(whereFrom)
  //   }
  // }

  // const [selectedLeague, setSelectedLeague] = useState();
  // const selectLeague = (league) => {
  //   if (league === selectedLeague){
  //     setSelectedLeague()
  //   } else {
  //     setSelectedLeague(league)
  //   }
  // }

  const [events, setEvents] = useState();
  const fetchEvents = async (indentDays, sportId) => {
    const options = {
      method: "GET",
      url: "https://flashlive-sports.p.rapidapi.com/v1/events/list",
      params: {
        indent_days: indentDays,
        timezone: "-4",
        locale: "en_INT",
        sport_id: sportId,
      },
      headers: {
        "X-RapidAPI-Key": "3fefe14d2dmsh136127b00ab3064p19a2d2jsn1cb73ff98a5e",
        "X-RapidAPI-Host": "flashlive-sports.p.rapidapi.com",
      },
    };

    try {
      setIsLoading(true);

      let fetchedEvents = [];
      await axios.request(options).then((res) => {
        let leagues = res.data.DATA;

        leagues.forEach((league) => {
          league.isOpen = false;
          fetchedEvents.push(league);
        });

        setEvents(fetchedEvents);

        setIsLoading(false);
      });
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  function getNumberOfDays(start, end) {
    const date1 = new Date(start);
    const date2 = new Date(end);

    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculating the time difference between two dates
    const diffInTime = date2.getTime() - date1.getTime();

    // Calculating the no. of days between two dates
    const diffInDays = Math.round(diffInTime / oneDay);

    return diffInDays === 0 ? 0 : -diffInDays; // Return negative value to indicate past dates
  }

  const todaysDate = new Date();
  const [scoresDate, setScoresDate] = useState(todaysDate);

  const [activeScoresTab, setActiveScoresTab] = useState();
  const toggleActiveScoresTab = (tab) => {
    setActiveScoresTab(tab);
    const numberOfDays = getNumberOfDays(new Date(scoresDate), new Date());
    fetchEvents(numberOfDays, tab.ID);
  };

  const addOneDay = () => {
    let date = new Date(scoresDate);
    date.setDate(date.getDate() + 1);
    const numberOfDays = getNumberOfDays(new Date(date), new Date());
    if (numberOfDays <= 7 && numberOfDays >= -7) {
      setScoresDate(new Date(date));
      fetchEvents(numberOfDays, activeScoresTab.ID);
    }
  };
  const subtractOneDay = () => {
    let date = new Date(scoresDate);
    date.setDate(date.getDate() - 1);
    const numberOfDays = getNumberOfDays(new Date(date), new Date());
    if (numberOfDays <= 7 && numberOfDays >= -7) {
      setScoresDate(new Date(date));
      fetchEvents(numberOfDays, activeScoresTab.ID);
    }
  };

  const [sports, setSports] = useState();
  const fetchSports = async () => {
    const options = {
      method: "GET",
      url: "https://flashlive-sports.p.rapidapi.com/v1/sports/list",
      headers: {
        "X-RapidAPI-Key": "3fefe14d2dmsh136127b00ab3064p19a2d2jsn1cb73ff98a5e",
        "X-RapidAPI-Host": "flashlive-sports.p.rapidapi.com",
      },
    };

    try {
      setIsLoading(true);

      await axios.request(options).then((res) => {
        let fetchedSports = [];
        let isFirst = true;
        res.data.DATA.forEach((sport) => {
          if (
            sport.NAME === "SOCCER" ||
            sport.NAME === "AMERICAN_FOOTBALL" ||
            sport.NAME === "BASEBALL" ||
            sport.NAME === "HOCKEY" ||
            sport.NAME === "MOTORSPORT" ||
            sport.NAME === "BASKETBALL" ||
            sport.NAME === "MMA" ||
            sport.NAME === "TENNIS" ||
            sport.NAME === "VOLLEYBALL" ||
            sport.NAME === "BOXING" ||
            sport.NAME === "GOLF" ||
            sport.NAME === "BEACH_SOCCER" ||
            sport.NAME === "AUTORACING" ||
            sport.NAME === "MOTORACING" ||
            sport.NAME === "CYCLING"
          ) {
            fetchedSports.push(sport);
            if (isFirst) {
              setActiveScoresTab(sport);
              // console.log(sport);
              fetchEvents(0, sport.ID);
              isFirst = false;
            }
          }
        });
        setSports(fetchedSports);

        setIsLoading(false);
      });
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchSports();
    // eslint-disable-next-line
  }, []);

  const toggleSportsPageTodaysLeagueEvent = (eventObject) => {
    let newEvents = [];

    events.forEach((obj) => {
      if (obj.TOURNAMENT_ID === eventObject.TOURNAMENT_ID) {
        obj.isOpen = !obj.isOpen;
      }
      newEvents.push(obj);
    });

    console.log(newEvents);

    setEvents(newEvents);
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="sportsPage" className="page">
      <h1>{t("sports").toUpperCase()}</h1>
      <div id="sportsPageMainTabSelectorsRow">
        <div
          className={classnames("sportsPageMainTabSelector", {
            active: activeMainTab === "SCORES",
          })}
          onClick={() => toggleActiveMainTab("SCORES")}
          style={{
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderRightWidth: 1,
          }}
        >
          <p>{t("scores").toUpperCase()}</p>
        </div>
        <div
          className={classnames("sportsPageMainTabSelector", {
            active: activeMainTab === "NEWS",
          })}
          onClick={() => toggleActiveMainTab("NEWS")}
          style={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderLeftWidth: 1,
          }}
        >
          <p>{t("news").toUpperCase()}</p>
        </div>
      </div>
      <ScrollMenu>
        {activeMainTab === "NEWS" ? (
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeNewsTab === "ALL",
            })}
            onClick={() => toggleActiveNewsTab("ALL")}
          >
            <p>{t("all").toUpperCase()}</p>
          </div>
        ) : null}
        {activeMainTab === "NEWS"
          ? // eslint-disable-next-line
            newsCategories?.map((newsCategory) => {
              // console.log(newsCategory.NAME.toUpperCase())
              if (
                newsCategory.NAME.toUpperCase() === "FOOTBALL" ||
                newsCategory.NAME.toUpperCase() === "AMERICAN SPORTS" ||
                newsCategory.NAME.toUpperCase() === "TENNIS" ||
                newsCategory.NAME.toUpperCase() === "BASKETBALL" ||
                newsCategory.NAME.toUpperCase() === "HOCKEY" ||
                newsCategory.NAME.toUpperCase() === "BASEBALL" ||
                newsCategory.NAME.toUpperCase() === "VOLLEYBALL" ||
                newsCategory.NAME.toUpperCase() === "COMBAT SPORTS" ||
                newsCategory.NAME.toUpperCase() === "GOLF" ||
                newsCategory.NAME.toUpperCase() === "MOTORSPORT" ||
                newsCategory.NAME.toUpperCase() === "ROAD CYCLING"
              )
                return (
                  <div
                    className={classnames("shopCategoriesMenuItem", {
                      active: activeNewsTab === newsCategory,
                    })}
                    onClick={() => toggleActiveNewsTab(newsCategory)}
                  >
                    <p>{newsCategory.NAME.toUpperCase()}</p>
                  </div>
                );
            })
          : sports?.map((sport) => {
              return (
                <div
                  className={classnames("shopCategoriesMenuItem", {
                    active: activeScoresTab === sport,
                  })}
                  onClick={() => toggleActiveScoresTab(sport)}
                >
                  <p>{sport.NAME.replace(/_/g, " ")}</p>
                </div>
              );
            })}
      </ScrollMenu>
      {activeMainTab === "NEWS" ? (
        <div id="sportsPageNewsContainer">
          {activeNewsTab === "ALL"
            ? mostReadNews?.map((article) => {
                return (
                  <div className="sportsPageNewsArticle">
                    <img
                      alt={
                        article.ARTICLE.IMAGES[0]
                          ? article.ARTICLE.IMAGES[0].ALT_TEXT
                          : "newsArticleImage"
                      }
                      src={
                        article.ARTICLE.IMAGES[0]
                          ? article.ARTICLE.IMAGES[0].URL
                          : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                      }
                    />
                    <p className="sportsPageNewsArticleTitle">
                      {article.ARTICLE.TITLE}
                    </p>
                  </div>
                );
              })
            : activeNewsCategoryNews?.map((article) => {
                return (
                  <div className="sportsPageNewsArticle">
                    <img
                      alt={
                        article.IMAGES[0]
                          ? article.IMAGES[0].ALT_TEXT
                          : "newsArticleImage"
                      }
                      src={
                        article.IMAGES[0]
                          ? article.IMAGES[0].URL
                          : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                      }
                    />
                    <p className="sportsPageNewsArticleTitle">
                      {article.TITLE}
                    </p>
                  </div>
                );
              })}
        </div>
      ) : (
        // SCORES TAB
        <div id="sportsPageScoresContainer">
          <div id="sportsPageDateToggleContainer">
            <FaChevronLeft onClick={subtractOneDay} />
            <p>{scoresDate.toLocaleDateString("de-DE")}</p>
            <FaChevronRight onClick={addOneDay} />
          </div>
          <div>
            {events?.map((league) => {
              return (
                <>
                  <div
                    className="sportsPageTodaysLeagueContainer"
                    onClick={() => toggleSportsPageTodaysLeagueEvent(league)}
                  >
                    <p className="sportsPageTodaysLeagueName">
                      {league.NAME}
                      {league.isOpen ? <FaChevronUp /> : <FaChevronDown />}
                    </p>
                  </div>
                  {league.isOpen
                    ? league.EVENTS.map((event) => {
                        console.log(event);
                        return (
                          <div className="sportsPageTodaysLeagueEvent">
                            <p className="sportsPageTodaysLeagueEventStage">
                              {event.STAGE.replace("_", " ")}
                            </p>
                            <div className="sportsPageTodaysLeagueEventImages">
                              <img
                                alt="homeImage"
                                src={event?.HOME_IMAGES[0]}
                              />
                              <img
                                alt="awayImage"
                                src={event?.AWAY_IMAGES[0]}
                              />
                            </div>
                            <div className="sportsPageTodaysLeagueEventNames">
                              <p>{event?.HOME_NAME}</p>
                              <p>{event?.AWAY_NAME}</p>
                            </div>
                            <div className="sportsPageTodaysLeagueEventScores">
                              <p>
                                {event.HOME_SCORE_CURRENT
                                  ? event.HOME_SCORE_CURRENT
                                  : 0}
                                {event?.WINNER === 1 && (
                                  <RxTriangleLeft
                                    style={{
                                      width: 30,
                                      height: 30,
                                      marginTop: -3,
                                    }}
                                  />
                                )}
                              </p>
                              <p>
                                {event.AWAY_SCORE_CURRENT
                                  ? event.AWAY_SCORE_CURRENT
                                  : 0}
                                {event?.WINNER === 2 && (
                                  <RxTriangleLeft
                                    style={{
                                      width: 30,
                                      height: 30,
                                      marginTop: -3,
                                    }}
                                  />
                                )}
                              </p>
                            </div>
                          </div>
                        );
                      })
                    : null}
                </>
              );
            })}
          </div>
        </div>
      )}
      {/* {
        selectedSport ?
        <h2 id='selectedSportHeader'>
          <FaChevronLeft onClick={() => selectedLeague ? setSelectedLeague() : selectedWhereFrom ? setSelectedWhereFrom() : setSelectedSport()} />
          {selectedSport}{selectedLeague ? ` - ${selectedWhereFrom} - ${selectedLeague}` : selectedWhereFrom ? ` - ${selectedWhereFrom}` : null}
        </h2>
        :
      <ScrollMenu>
        <div onClick={() => selectSport('PRO SOCCER')} className='sportsPageSport'>
          <img
            alt="sportImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
          />
          <p>
            PRO SOCCER
          </p>
        </div>
        <div onClick={() => selectSport('PRO AMERICAN FOOTBALL')} className='sportsPageSport'>
          <img
            alt="sportImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
          />
          <p>
            PRO AMERICAN FOOTBALL
          </p>
        </div>
        <div onClick={() => selectSport('PRO BASEBALL')} className='sportsPageSport'>
          <img
            alt="sportImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
          />
          <p>
            PRO BASEBALL
          </p>
        </div>
        <div onClick={() => selectSport('PRO HOCKEY')} className='sportsPageSport'>
          <img
            alt="sportImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
          />
          <p>
            PRO HOCKEY
          </p>
        </div>
        <div onClick={() => selectSport('PRO RACING')} className='sportsPageSport'>
          <img
            alt="sportImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
          />
          <p>
            PRO RACING
          </p>
        </div>
        <div onClick={() => selectSport('PRO BASKETBALL')} className='sportsPageSport'>
          <img
            alt="sportImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
          />
          <p>
            PRO BASKETBALL
          </p>
        </div>
        <div onClick={() => selectSport('MMA')} className='sportsPageSport'>
          <img
            alt="sportImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
          />
          <p>
            MMA
          </p>
        </div>
        <div onClick={() => selectSport('COLLEGE FOOTBALL')} className='sportsPageSport'>
          <img
            alt="sportImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
          />
          <p>
            COLLEGE FOOTBALL
          </p>
        </div>
        <div onClick={() => selectSport('COLLEGE BASKETBALL')} className='sportsPageSport'>
          <img
            alt="sportImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
          />
          <p>
            COLLEGE BASKETBALL
          </p>
        </div>
      </ScrollMenu>
      }
      {
        selectedSport ?
          <div>
            {
              !selectedWhereFrom ?
                <h2>
                  WHERE FROM?
                </h2>
              :
                null
            }
            {
              selectedWhereFrom ?
                selectedLeague ?
                  <div>
                    <h2>
                      MATCHES
                    </h2>
                    <div>
                      <div className='sportsPageMatchContainer'>
                        <div className='sportsPageMatchTeamsContainer'>
                          <div style={{marginBottom: '1rem'}}>
                            <img
                              alt="sportImage"
                              src="https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png"
                            />
                            <h3>
                              TEAM NAME
                            </h3>
                          </div>
                          <div>
                            <img
                              alt="sportImage"
                              src="https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png"
                            />
                            <h3>
                              TEAM NAME
                            </h3>
                          </div>
                        </div>
                        <div className='sportsPageMatchDetailsContainer'>
                          <h4 className='sportsPageMatchDateAndTime'>
                            {new Date().toLocaleTimeString("en-US", {weekday: "long", year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"})}
                          </h4>
                          <h4 className='sportsPageMatchLeagueStage'>
                            LEAGUE STAGE
                          </h4>
                          <Button className='primaryBtn'>
                            PLAY GAME
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                  :
                  <div>
                  <h2>
                    LEAGUES
                  </h2>
                  <ScrollMenu>
                    <div onClick={() => selectLeague('LEAGUE')} className='sportsPageSport'>
                      <img
                        alt="leagueImage"
                        src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                      />
                      <p>
                        LEAGUE
                      </p>
                  </div>
                  </ScrollMenu>
                  <div style={{marginTop: '1rem'}}>
                    <p style={{color: '#FFFFFF', textAlign: 'center'}}>
                      Please select a league
                    </p>
                  </div>
                  </div>
              :
                <div>
                <ScrollMenu>
                  <div onClick={() => selectWhereFrom('PLACE')} className='sportsPageSport'>
                    <img
                      alt="whereFromImage"
                      src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                    />
                    <p>
                      PLACE
                    </p>
                  </div>
                </ScrollMenu>
                <div style={{marginTop: '1rem'}}>
                  <p style={{color: '#FFFFFF', textAlign: 'center'}}>
                    Please select where from
                  </p>
                </div>
                </div>
            }
          </div>
        :
          <div style={{marginTop: '1rem'}}>
            <p style={{color: '#FFFFFF', textAlign: 'center'}}>
              Please select a sport
            </p>
          </div>
      } */}
    </div>
  );
}

export default SportsPage;
